const R_F_036 = require('./R-F-036.webp');
export default [R_F_036];
